import React, { useCallback, useEffect } from "react";
import dayjs from "dayjs";

export const AuthProviderContext = React.createContext();

const TTL = 60 * 24; //Time to live (minutes) for token 

const AuthProvider = ({ children }) => {
    const [state, dispatch] = React.useReducer((state, action) => {
        return {
            ...state,
            [action.key]: action.value
        }
    }, {
        defaultToken: process.env.REACT_APP_API_TOKEN,
        token: null
    })

    const dispatchMultiple = useCallback(arr => {
        arr.forEach(action => dispatch(action))
    }, [dispatch])

    const setToken = useCallback(token => {
        try {
            localStorage.setItem("token", JSON.stringify({
                value: token,
                expiry: dayjs().add(TTL, "minute").toISOString()
            }))
            dispatch({
                key: "token",
                value: token
            })
        }
        catch (error) {
            console.log(error)
        }
    }, [])

    useEffect(() => {
        try {
            const maybeToken = JSON.parse(
                localStorage.getItem("token")
            );

            if (
                !maybeToken ||
                !maybeToken.expiry ||
                dayjs(maybeToken.expiry).isBefore(dayjs())
            ) {
                localStorage.removeItem("token");
                return dispatch({
                    key: "token",
                    value: null
                })
            }

            setToken(maybeToken.value)
        } catch (error) {
            console.log(error)
        }
    }, [])

    return (
        <AuthProviderContext.Provider
            value={{
                state,
                dispatch,
                dispatchMultiple,
                setToken
            }}
        >
            {
                children
            }
        </AuthProviderContext.Provider>
    )
}

export default AuthProvider;